const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 39250 29450",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27151.246,8658.045c-2709.598,-2543.937 -5884.166,-3200.678 -6722.975,-3334.678c565.308,-1527.022 1438.43,-3797.033 1655.86,-4132.927c140.652,-17.692 282.304,-25.81 424.006,-24.294c616.327,0 1936.013,128.162 3846.966,988.419c2759.766,1242.227 3493.236,2639.412 3638.74,2981.183l-2842.597,3522.297Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22508.136,1333.684c602.972,0 1895.898,126.482 3775.89,973.338c2493.018,1124.114 3298.364,2380.581 3512.443,2805.268l-2661.08,3301.165c-1316.285,-1186.437 -2853.15,-2101.274 -4522.715,-2692.191c-636.384,-229.434 -1290.275,-406.75 -1955.27,-530.245c624.73,-1681.144 1303.78,-3411.711 1532.114,-3843.935c74.427,-6.697 181.467,-13.4 320.268,-13.4l-1.651,0Zm1.651,-335.058c-169.913,-3.571 -339.775,8.208 -507.587,35.183c-195.722,65.334 -1801.413,4426.109 -1801.413,4426.109c0,0 3811.003,389.493 6968.065,3444.368l3010.658,-3737.576c0,0 -501.785,-1697.04 -3763.335,-3164.59c-1909.303,-860.257 -3239.843,-1005.17 -3913.041,-1005.17l6.652,1.676Z",
    style: {
      fill: "#a0c6f4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20758.592,5799.143c0,0 3747.48,378.639 6055.629,2502.071",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23993.383,5615.725l1398.315,-2722.347l1436.779,2838.79l-2835.094,-116.443Z",
    style: {
      fill: "#a0c6f4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24265.183,5577.161l1398.315,-2722.317l1436.729,2838.76l-2835.044,-116.443Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22953.901,832.769c0,0 4203.197,381.966 6812.458,3487.944",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25100.641,12896.506c-230.785,-167.562 -382.141,-283.955 -382.141,-283.955c63.523,-83.781 1074.596,-1163.528 1660.011,-2032.998c0,0 -1184.186,2386.479 -1277.87,2316.953Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10775.717,5033.546c112.892,188.484 162.21,113.057 487.529,83.746c325.32,-29.311 788.64,212.778 950.9,614.026c162.21,401.198 112.892,463.221 25.059,513.439c-87.782,50.269 -712.512,125.646 -737.622,251.293",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19203.07,25426.769l-291.857,-493.382l-1033.681,1726.386l271,209.427l1054.538,-1442.431Z",
    style: {
      fill: "#f9865f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12337.892,21150.645c0,0 -536.047,-872.021 -306.063,-1300.029l1709.379,183.418l-1403.317,1116.611Z",
    style: {
      fill: "#f9865f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12337.892,21150.645l102.038,236.187l-315.266,1233.004c-19.957,76.178 -18.007,156.408 5.502,231.485c23.509,75.128 67.675,142.102 127.447,193.221l1563.075,-2314.402c71.626,-106.539 102.988,-235.137 88.433,-362.734c-14.555,-127.597 -74.077,-245.79 -167.912,-333.373l-349.579,-324.97l-1053.738,1441.581Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11501.634,6499.401c489.23,-11.704 1109.759,-42.716 985.163,-418.804c-124.646,-376.088 -585.416,-1304.2 -1643.355,-1025.277c0,0 -372.137,310.764 92.834,870.32c464.971,559.556 565.358,573.761 565.358,573.761Z",
    style: {
      fill: "#2a1e33",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13978.746,20050.79c0,0 -836.308,-2471.01 -128.797,-3555.759c585.416,-895.43 2490.467,560.356 2751.413,753.878l1364.002,-2464.357c0,0 -314.466,-442.263 -1087.2,-875.322c-772.734,-433.059 -3966.56,-1729.737 -5467.713,642.437c-554.454,876.223 -562.807,4638.058 501.785,6079.638l2066.511,-580.514Z",
    style: {
      fill: "#616594",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13978.746,20050.79c0,0 -836.308,-2471.01 -128.797,-3555.759c585.416,-895.48 2490.467,560.356 2751.413,753.878",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17965.364,14784.551c-620.528,654.191 -2459.555,3840.564 -2873.508,5360.924c-552.804,2037.15 -344.577,3726.672 2696.193,7036.19l1469.391,-2144.389c0,0 -1033.681,-1571.429 -836.308,-3053.174c279.353,-2143.539 1802.213,-4221.754 2572.447,-5540.19l-3028.215,-1659.361Z",
    style: {
      fill: "#616594",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18198.7,15060.953l2444.5,1922.408l730.919,-1112.41l-3175.419,-809.998Z",
    style: {
      fill: "#2286aa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32241.82,13040.559c381.34,82.08 671.797,227.584 871.421,436.411c199.874,209.427 109.54,318.317 36.814,381.991c-72.777,63.623 -354.631,-9.253 -599.671,-227.034c-244.99,-217.78 -308.564,-591.368 -308.564,-591.368Z",
    style: {
      fill: "#ff8a66",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24718.5,12612.551c63.523,-83.781 1074.596,-1163.528 1660.011,-2032.998c0,0 1768.801,1985.231 1961.122,2049.755c71.076,23.409 501.785,17.556 1043.734,12.555c909.885,-10.054 2119.98,-19.257 2387.629,115.593c426.507,212.728 682.401,319.968 788.59,619.028c106.239,299.01 148.905,494.182 -106.189,511.788c-298.56,21.758 -490.08,-362.734 -490.08,-362.734c-281.204,151.306 -574.011,279.853 -875.572,384.492c0,0 -2267.235,881.224 -3782.593,454.867c-412.302,-116.443 -2586.652,-1752.345 -2586.652,-1752.345Z",
    style: {
      fill: "#f9865f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10975.591,4682.582c-194.021,74.552 -312.765,163.34 -199.874,350.974c112.892,187.624 162.21,113.097 487.529,83.786c325.32,-29.361 788.64,212.728 950.9,613.976c162.21,401.248 112.892,463.221 25.059,513.489c-87.782,50.218 -712.512,125.646 -737.572,251.293c-25.109,125.646 250.892,495.032 828.755,470.723l137.15,-25.109c0,0 1210.096,1183.586 1385.76,1358.65c175.615,175.064 1461.838,1048.736 2174.35,1226.301c538.598,134.85 1630.8,-38.514 2286.442,-167.512c318.617,-62.823 535.247,-113.942 535.247,-113.942c0,0 -492.581,-888.727 -592.968,-2254.08c0,0 -1177.483,189.32 -1960.272,361.833c0,0 -1826.472,-1020.226 -2714.599,-1471.692c0,0 -776.086,-951.585 -1139.069,-1077.232c-362.934,-125.646 -1204.243,-221.136 -1466.84,-121.46Z",
    style: {
      fill: "#f9865f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18310.741,9363.305c318.617,-62.823 535.247,-113.892 535.247,-113.892c0,0 -596.27,-753.878 -695.806,-2117.58c0,0 -269.299,290.657 -185.668,1063.792c105.389,976.71 346.227,1167.68 346.227,1167.68Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18125.073,6978.577c0,0 16.756,1669.415 463.321,2365.471l159.759,-64.474c0,0 -2103.324,2465.158 -2784.075,4075.951c-111.191,263.847 4368.008,3129.452 5029.502,3089.237c0,0 2182.754,-3336.328 2927.078,-4325.592l802.846,623.229c0,0 1573.079,-1596.588 1657.51,-2162.796c0,0 -1519.559,-1852.032 -2759.766,-2394.832c-1240.257,-542.8 -2360.019,-1470.892 -3695.611,-1441.581c-1155.776,17.606 -1800.563,235.387 -1800.563,235.387Z",
    style: {
      fill: "#2286aa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24720.151,12742.349l-801.995,-623.179l127.947,-348.478l674.048,971.658Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25941.15,6142.569c-140.502,438.111 -546.101,1703.777 -998.568,1859.585c-452.417,155.807 -919.889,-39.364 -919.889,-39.364l-481.727,246.241c-53.52,161.66 -434.06,300.711 -924.941,320.018c-363.784,14.205 -585.416,-454.017 -477.526,-792.442c49.318,-155.807 234.136,-921.389 234.136,-921.389c0,0 389.743,-1437.379 752.677,-1733.938c362.984,-296.514 695.806,-591.368 1653.359,-203.535c1458.537,593.028 1162.478,1264.826 1162.478,1264.826Z",
    style: {
      fill: "#f9865f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22357.406,6692.538c-15.778,54.792 -24.345,86.39 -24.345,86.39c0,0 -88.235,365.502 -159.042,642.812c-733.206,-391.743 -1470.119,-732.787 -2287.959,-714.839c-139.246,2.121 -271.075,7.148 -395.253,14.349c-20.911,-73.326 -32.108,-150.729 -32.108,-230.727c0,-464.032 376.735,-840.766 840.766,-840.766c6.718,0 209.602,-169.109 216.283,-168.952l132.337,-200.398c-84.46,-138.106 -132.337,-295.711 -132.337,-462.98c0,-544.733 507.773,-986.987 1133.207,-986.987c121.405,0 238.376,16.664 348.061,47.507c59.302,-496.323 541.644,-883.817 1127.078,-883.817c404.148,0 759.166,184.667 959.792,462.323l31.193,0c16.799,-449.27 386.823,-808.856 840.171,-808.856c453.347,0 823.372,359.586 840.171,808.856l202.361,0c153.279,-161.811 370.132,-262.802 610.387,-262.802c462.312,0 837.973,373.947 840.751,835.61c462.425,1.888 837.267,377.895 837.267,840.759c0,140.716 -34.644,273.404 -95.86,389.993l236.561,220.79c372.424,86.382 650.32,420.527 650.32,819.067c0,389.637 173.04,735.507 -186.847,830.691c0,0 -263.574,90.293 -263.574,200.728c0,134.418 263.574,283.853 263.574,605.779c0,464.032 -236.002,866.238 -700.034,866.238c-356.539,0 -545.413,117.669 -667.588,-195.861c15.02,62.852 22.975,128.435 22.975,195.861c0,117.758 -24.262,229.894 -68.055,331.678c2.495,26.36 -4.919,154.088 -28.739,226.3c-35.291,106.991 -49.047,266.69 -183.008,415.643c-73.625,389.102 -415.726,683.754 -826.104,683.754c-63.654,0 -125.666,-7.089 -185.288,-20.52c-154.822,-181.038 -503.232,-576.931 -937.393,-998.178c-146.66,-154.73 -327.944,-324.237 -550.881,-501.832c-385.779,-327.154 -798.699,-622.783 -1184.575,-791.669l-17.651,-7.754l419.099,-214.227c0,0 467.472,195.172 919.889,39.364c452.467,-155.807 858.066,-1421.473 998.568,-1859.585c0,0 16.199,-36.758 22.351,-100.666c-36.675,-127.689 -63.418,-231.689 -100.719,-269.044c-139.651,-139.902 -289.357,-300.711 -804.496,-107.189c-515.19,193.471 -1052.087,-376.138 -1052.087,-376.138c0,0 -83.631,687.703 -171.413,753.878c-87.832,66.174 -257.595,150.806 -214.929,-171.713c42.616,-322.469 96.986,-290.657 64.374,-376.088c-32.612,-85.431 -177.265,-357.682 -482.528,-118.093c-342.876,262.997 -128.797,814.15 -128.797,814.15c-64.374,268.049 -342.876,805.847 -526.044,708.661c-67.326,-35.714 -118.493,-91.59 -149.88,-171.497Z",
    style: {
      fill: "#3f190c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23179.684,6324.336c-204.875,-167.512 -347.078,-475.775 -167.262,-778.987c179.816,-303.212 475.025,-344.277 564.508,-229.535c89.483,114.792 124.596,308.263 40.115,537.798",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#2a1e33",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18149.332,26869.2l102.038,235.387l-315.266,1233.004c-19.957,76.128 -18.007,156.408 5.502,231.485c23.509,75.128 67.675,142.102 127.447,193.221l1561.375,-2314.452c71.676,-106.489 103.038,-235.087 88.433,-362.684c-14.555,-127.597 -74.077,-245.79 -167.862,-333.373l-349.579,-325.02l-1052.087,1442.431Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23516.708,4388.559c0,0 -120.444,-389.508 -479.176,-492.536",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#2a1e33",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15910.558,13237.431l4330.394,-6058.681",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22026.409,7602.607c-156.358,203.525 -227.434,1078.047 490.931,1134.168c409.701,40.815 821.753,-49.818 1176.683,-258.845",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12438.279,4808.223c0,0 495.082,655.896 572.861,889.583",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30974.003,13605.967c0,0 334.473,272.25 989.314,-83.781c238.338,-128.147 68.575,-430.508 -234.136,-355.131c-302.761,75.378 -660.693,-37.714 -660.693,-37.714",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32355.562,13078.273c0,0 316.967,371.087 308.564,591.368",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27685.643,13038.058c0,0 286.856,-382.791 653.991,-408.75",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15588.589,7975.344c0,0 167.262,-522.692 704.159,-618.178",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17042.924,15906.164l-640.586,1223.801c0,0 -2110.827,3577.567 -1394.113,5889.418",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18912.863,20010.575l2076.564,-3565.813c0,0 2722.152,-3954.506 3000.605,-4508.21l960.954,-1780.005",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16201.615,13617.721c0,0 3693.91,2697.193 4788.613,2827.041",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18125.073,6978.577c0,0 0,1692.873 452.467,2386.429",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26259.768,10311.504c-116.243,696.957 -1657.56,2161.996 -1657.56,2161.996",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14755.632,18999.553c121.045,0 219.131,-98.236 219.131,-219.481c0,-121.195 -98.086,-219.431 -219.131,-219.431c-120.995,0 -219.081,98.236 -219.081,219.431c0,121.245 98.086,219.481 219.081,219.481Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35331.958,23500.21l-121.295,-840.159l715.063,476.625l-373.838,81.23l-219.931,282.304Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11601.971,9157.279c-1355.649,-1198.691 -3596.074,1789.209 4599.643,11299.76c4729.241,5486.57 8446.61,5978.251 8948.394,4069.298c903.183,-3424.311 -2358.368,-4289.579 -1144.071,-2948.536c1764.6,1950.068 6783.197,2362.17 10523.974,542.8c3690.609,-1795.911 1421.723,-4584.388 1192.589,-4747.748",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34591.835,22322.476c120.995,0 219.081,-98.236 219.081,-219.431c0,-121.245 -98.086,-219.481 -219.081,-219.481c-121.045,0 -219.131,98.236 -219.131,219.481c0,121.195 98.086,219.431 219.131,219.431Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31400.51,23896.405l6500.543,-3670.551",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11737.471,9554.325c120.995,0 219.081,-98.286 219.081,-219.481c0,-121.195 -98.086,-219.481 -219.081,-219.481c-121.045,0 -219.131,98.286 -219.131,219.481c0,121.195 98.086,219.481 219.131,219.481Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17329.78,5270.598c260.046,0 470.823,-211.128 470.823,-471.594c0,-260.451 -210.778,-471.594 -470.823,-471.594c-260.046,0 -470.823,211.143 -470.823,471.594c0,260.466 210.778,471.594 470.823,471.594Z",
    style: {
      fill: "#ff6d66",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8792.837,1204.696c-41.065,-0.165 -81.23,11.874 -115.443,34.603c-34.213,22.723 -60.922,55.11 -76.778,93.054c-15.806,37.939 -20.057,79.734 -12.154,120.089c7.953,40.35 27.61,77.444 56.571,106.579c29.011,29.136 65.924,49.003 106.189,57.091c40.265,8.083 82.03,4.016 119.944,-11.679c37.964,-15.701 70.426,-42.326 93.234,-76.503c22.808,-34.183 35.013,-74.377 35.013,-115.498c0,-54.95 -21.758,-107.665 -60.472,-146.599c-38.714,-38.934 -91.234,-60.917 -146.104,-61.138Z",
    style: {
      fill: "#a0c6f4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36506.94,26935.374c114.092,0 206.576,-92.634 206.576,-206.876c0,-114.292 -92.484,-206.926 -206.576,-206.926c-114.092,0 -206.576,92.634 -206.576,206.926c0,114.242 92.484,206.876 206.576,206.876Z",
    style: {
      fill: "#fad8b0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32811.33,17372.003l-2225.369,-1044.535c-39.264,-19.407 -72.177,-49.568 -95.035,-86.932c-22.808,-37.414 -34.613,-80.48 -33.963,-124.296c0.6,-43.866 13.605,-86.582 37.464,-123.345c23.859,-36.714 57.621,-65.924 97.386,-84.231l4136.323,-1822.721c28.961,-12.855 60.322,-19.457 91.984,-19.457c31.662,0 63.023,6.602 91.984,19.457l2843.447,1221.3l-4944.22,2064.76Z",
    style: {
      fill: "#2a1e33",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32676.68,13937.689c5.002,921.389 137.15,3434.364 137.15,3434.364l4944.22,-2068.161l-111.241,-3497.137c-1.451,-49.618 -15.156,-98.086 -39.815,-141.102c-24.709,-43.016 -59.622,-79.229 -101.687,-105.439c-42.065,-26.21 -89.983,-41.565 -139.401,-44.766c-49.418,-3.151 -98.886,5.952 -143.953,26.61l-4255.917,1943.315c-86.832,39.164 -160.409,102.788 -211.778,183.067c-51.369,80.33 -78.329,173.864 -77.579,269.249Z",
    style: {
      fill: "#121212",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32811.33,17372.003l4944.22,-2068.111l-111.241,-3497.187c0,0 -32.612,-381.941 -424.856,-264.697",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35203.96,14858.228l333.723,-789.891",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35537.683,14858.228l333.673,-789.891",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9683.515,23477.601c114.042,0 206.526,-92.634 206.526,-206.926c0,-114.242 -92.484,-206.876 -206.526,-206.876c-114.092,0 -206.576,92.634 -206.576,206.876c0,114.292 92.484,206.926 206.576,206.926Z",
    style: {
      fill: "#ff6d66",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27122.835,24585.809c158.858,0 287.656,-129.048 287.656,-288.156c0,-159.159 -128.797,-288.156 -287.656,-288.156c-158.909,0 -287.706,128.997 -287.706,288.156c0,159.109 128.797,288.156 287.706,288.156Z",
    style: {
      fill: "#ff6d66",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11827.754,26344.007c818.901,376.939 1710.58,568.509 2611.762,561.207c16.756,0.15 33.262,3.801 48.468,10.754c15.206,6.953 28.811,17.056 39.865,29.611c11.054,12.555 19.307,27.36 24.259,43.316c5.002,16.006 6.502,32.912 4.502,49.518l-180.616,1434.028c-3.601,24.909 -15.056,47.968 -32.662,65.924c-17.556,17.907 -40.415,29.761 -65.224,33.762c-366.285,69.526 -1839.827,272.25 -2945.434,-670.097c-16.806,-14.455 -29.211,-33.362 -35.713,-54.57c-6.502,-21.208 -6.903,-43.816 -1.05,-65.224l364.584,-1367.854c5.052,-16.606 13.705,-31.862 25.309,-44.766c11.604,-12.855 25.91,-23.008 41.865,-29.711c15.956,-6.752 33.212,-9.854 50.519,-9.153c17.306,0.75 34.213,5.252 49.568,13.255Z",
    style: {
      fill: "#fff7dc",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11957.402,26762.811c0,0 637.235,897.13 864.718,1026.128c227.484,128.997 1455.186,-604.773 1455.186,-604.773",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13423.442,27664.993l669.847,689.354",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12492.649,27531.794l-783.638,213.579",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31588.679,
    y: 9372.508,
    width: 748.476,
    height: 749.726,
    style: {
      fill: "#ffe1c0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31689.867,19482.03l222.432,386.192l222.482,386.142l-888.977,0l221.582,-386.142l222.482,-386.192Z",
    style: {
      fill: "#a0c6f4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13705.246,2387.442l58.572,-1752.35c-6.702,-167.528 60.172,-215.274 160.559,-237.89c475.025,-104.706 1923.458,-427.197 3489.885,37.694c203.175,60.31 196.522,167.529 193.171,264.694l-56.021,1670.26c-4.102,31.211 -14.655,61.223 -31.011,88.097c-16.406,26.87 -38.214,50.013 -64.024,67.925c-25.86,17.917 -55.17,30.206 -86.032,36.083c-30.911,5.877 -62.673,5.207 -93.234,-1.961c-569.36,-68.25 -1142.821,-96.24 -1716.082,-83.766c-551.403,-2.356 -1102.006,42.201 -1645.856,133.184c-155.557,29.316 -214.079,-84.601 -209.927,-221.972Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14233.79,2136.144l914.937,-1072.185l1011.923,1000.984c-349.579,-118.108 -1926.859,71.201 -1926.859,71.201Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15708.183,1556.496l739.322,-593.048l623.029,445.624l23.409,696.081l-934.144,-45.232",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14628.986,980.009c8.503,-84.231 -64.724,-160.614 -163.51,-170.613c-98.786,-10.004 -185.768,50.168 -194.272,134.399c-8.503,84.231 64.724,160.619 163.51,170.618c98.786,10.004 185.768,-50.173 194.272,-134.404Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31384.604,25147.016l613.026,1134.168c64.374,101.337 41.815,159.159 -14.255,211.078c-262.597,243.74 -1062.891,985.913 -2233.722,1275.72c-151.356,37.714 -187.319,-33.512 -220.781,-96.335l-585.416,-1081.348c-8.853,-21.458 -13.155,-44.466 -12.655,-67.625c0.45,-23.159 5.752,-46.017 15.506,-67.025c9.754,-21.008 23.759,-39.765 41.115,-55.12c17.356,-15.306 37.664,-26.86 59.722,-33.912c387.093,-168.312 761.63,-364.234 1120.663,-586.366c353.63,-201.774 689.404,-433.51 1003.519,-692.705c83.631,-83.781 167.262,-29.311 213.279,59.472Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31143.766,25506.348l-183.167,1021.126l-1013.573,-258.845c263.397,-56.971 1196.741,-762.281 1196.741,-762.281Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30420.349,26421.085l-250.042,651.64l-560.306,-51.069l-273.501,-433.91l609.674,-319.117",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31483.741,26438.641c66.374,-30.361 99.337,-100.737 73.627,-157.108c-25.759,-56.371 -100.387,-77.429 -166.761,-47.067c-66.374,30.361 -99.337,100.687 -73.627,157.108c25.759,56.371 100.387,77.429 166.761,47.067Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28399.005,5782.387l2491.367,1909.853c12.955,10.004 27.76,17.306 43.566,21.508c15.806,4.202 32.262,5.202 48.468,2.951c16.206,-2.301 31.812,-7.753 45.867,-16.156c14.055,-8.353 26.31,-19.457 36.013,-32.612l376.339,-510.988c18.507,-25.459 26.46,-57.071 22.258,-88.283c-4.202,-31.211 -20.257,-59.572 -44.816,-79.229l-2456.204,-1969.295c-13.055,-10.409 -28.01,-18.057 -44.066,-22.483c-16.106,-4.427 -32.862,-5.537 -49.368,-3.266c-16.506,2.271 -32.362,7.878 -46.667,16.481c-14.255,8.603 -26.66,20.022 -36.363,33.562l-411.451,569.595c-18.507,25.81 -26.21,57.871 -21.508,89.283c4.652,31.412 21.358,59.772 46.567,79.079Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28583.023,5696.955l603.772,424.706l357.131,-426.357l-604.673,-505.136l-356.231,506.787Z",
    style: {
      fill: "#ff6d66",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29414.279,6287.523l605.473,480.777l324.519,-399.547l-609.674,-495.032l-320.318,413.802Z",
    style: {
      fill: "#fad8b0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30222.977,6952.568l604.673,424.706l287.656,-370.236l-572.011,-479.977l-320.318,425.507Z",
    style: {
      fill: "#a0c6f4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33370.836,3111.994l567.809,4774.568c2.601,25.109 10.204,49.468 22.358,71.626c12.154,22.108 28.611,41.565 48.418,57.221c19.857,15.606 42.566,27.11 66.925,33.762c24.309,6.602 49.768,8.303 74.728,4.902l961.754,-132.349c48.268,-6.452 92.084,-31.512 122.195,-69.826c30.161,-38.314 44.216,-86.882 39.214,-135.4l-465.821,-4803.023c-2.551,-25.374 -10.204,-49.963 -22.558,-72.287c-12.305,-22.318 -29.011,-41.9 -49.118,-57.566c-20.057,-15.661 -43.116,-27.075 -67.775,-33.552c-24.609,-6.477 -50.319,-7.878 -75.478,-4.122l-1062.941,155.797c-48.818,7.078 -92.934,33.077 -122.795,72.402c-29.861,39.324 -43.166,88.828 -36.914,137.846Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33660.992,3223.405l179.816,1117.416l848.012,-62.823l-92.834,-1203.693l-934.994,149.1Z",
    style: {
      fill: "#ff6d66",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33901.881,4768.008l119.594,1178.539l784.439,-70.326l-108.74,-1197.841l-795.293,89.628Z",
    style: {
      fill: "#91ba83",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34036.531,6367.902l179.766,1117.411l713.363,-78.729l-86.132,-1141.72l-806.997,103.038Z",
    style: {
      fill: "#fad8b0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32131.429,4128.898l1572.229,4629.634c6.402,18.857 16.456,36.263 29.611,51.169c13.205,14.956 29.211,27.11 47.117,35.763c17.907,8.653 37.314,13.605 57.171,14.655c19.857,1.05 39.715,-1.851 58.472,-8.603l985.163,-355.131c36.363,-13.305 66.224,-40.165 83.331,-74.928c17.156,-34.813 20.257,-74.878 8.653,-111.891l-1476.093,-4674.876c-6.202,-19.412 -16.256,-37.364 -29.561,-52.774c-13.305,-15.406 -29.611,-27.955 -47.868,-36.879c-18.307,-8.928 -38.214,-14.045 -58.522,-15.046c-20.357,-1.005 -40.665,2.126 -59.722,9.208l-1080.498,401.228c-36.714,13.26 -66.725,40.505 -83.481,75.798c-16.756,35.293 -18.907,75.788 -6.002,112.671Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32450.047,4213.494l408.1,1056.254l816.251,-238.713l-340.375,-1158.461l-883.975,340.921Z",
    style: {
      fill: "#a0c6f4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33007.002,5674.347l361.283,1128.315l752.677,-232.886l-354.581,-1149.223l-759.38,253.793Z",
    style: {
      fill: "#f9865f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33470.322,7211.413l408.1,1055.439l681.601,-226.183l-321.118,-1098.955l-768.583,269.699Z",
    style: {
      fill: "#fad8b0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20281.067,9976.481l-7940.623,0c-253.143,0 -458.319,205.526 -458.319,459.019l0,1076.396c0,253.493 205.176,459.019 458.319,459.019l7940.623,0c253.093,0 458.319,-205.526 458.319,-459.019l0,-1076.396c0,-253.493 -205.226,-459.019 -458.319,-459.019Z",
    style: {
      fill: "#7595ec",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17305.521,10563.647l-4328.694,0c-83.581,0 -151.356,67.875 -151.356,151.606c0,83.781 67.775,151.656 151.356,151.656l4328.694,0c83.581,0 151.356,-67.875 151.356,-151.656c0,-83.731 -67.775,-151.606 -151.356,-151.606Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12868.938,11260.554l7358.609,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9103.752,6223.799l125.196,137.301c25.459,27.86 38.764,64.724 37.064,102.488c-1.701,37.714 -18.307,73.227 -46.117,98.686l-205.025,187.569c-27.81,25.459 -64.624,38.814 -102.288,37.114c-37.664,-1.701 -73.127,-18.357 -98.586,-46.217l-125.196,-137.301l414.953,-379.64Z",
    style: {
      fill: "#91ba83",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7976.186,5956.901l590.567,647.538c30.511,33.462 82.33,35.813 115.793,5.252l408.1,-373.437c33.462,-30.561 35.813,-82.48 5.252,-115.943l-590.517,-647.538c-30.511,-33.462 -82.38,-35.813 -115.793,-5.252l-408.15,373.437c-33.412,30.561 -35.763,82.48 -5.252,115.943Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6617.636,
    y: 8899.284,
    width: 741.773,
    height: 678.45,
    style: {
      fill: "#ff6d66",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6617.636,8462.824l0,436.411l-443.263,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31058.434,
    y: 1237.358,
    width: 741.823,
    height: 678.49,
    style: {
      fill: "#fad8b0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31058.434,800.948l0,436.416l-443.213,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10980.593,5431.407c-7693.938,-3193.081 -13611.591,2956.889 885.626,12373.655c1141.57,742.173 2892.765,1005.17 2892.765,1005.17",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3906.348,5865.317c121.015,0 219.111,-98.236 219.111,-219.431c0,-121.195 -98.096,-219.481 -219.111,-219.481c-121.01,0 -219.106,98.286 -219.106,219.481c0,121.195 98.096,219.431 219.106,219.431Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2511.405,4440.498l240.018,-231.19l551.118,316.632l277.652,856.9l-847.172,-355.156l-221.617,-587.186Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2751.423,4209.308l-240.018,231.185l-134.645,-163.34l229.98,-221.136l144.683,153.291Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3580.198,5382.84l-551.123,-605.608",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4911.578,20760.301l597.1,3085.836c3.201,16.056 9.554,31.312 18.607,44.867c9.103,13.555 20.808,25.209 34.413,34.213c13.605,9.053 28.861,15.306 44.867,18.407c16.006,3.101 32.512,3.001 48.468,-0.3l620.528,-132.349c31.111,-6.652 58.371,-25.159 76.178,-51.519c17.757,-26.41 24.659,-58.672 19.157,-90.033l-530.195,-3105.143c-2.851,-16.406 -9.053,-32.062 -18.157,-46.017c-9.053,-13.955 -20.908,-25.91 -34.713,-35.163c-13.855,-9.203 -29.411,-15.556 -45.767,-18.607c-16.356,-3.001 -33.162,-2.701 -49.368,0.95l-684.952,152.456c-15.651,3.001 -30.561,9.053 -43.871,17.857c-13.31,8.803 -24.759,20.107 -33.687,33.362c-8.933,13.205 -15.176,28.06 -18.367,43.716c-3.191,15.656 -3.276,31.762 -0.24,47.467Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5108.131,20818.922l170.563,719.515l548.652,-81.23l-117.093,-779.837l-602.122,141.552Z",
    style: {
      fill: "#ff6d66",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5338.916,21814.039l133.799,761.43l507.637,-82.931l-127.947,-775.686l-513.489,97.186Z",
    style: {
      fill: "#fad8b0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5502.826,22849.37l169.762,719.515l460.82,-86.232l-109.54,-738.822l-521.042,105.539Z",
    style: {
      fill: "#a0c6f4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22031.461,28492.548l2525.63,-676.799l96.986,273.901l-2554.891,664.245l-67.725,-261.346Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21680.182,28139.067l73.627,229.535",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21609.105,28288.973l213.279,-73.677",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21558.087,29016.09l137.15,433.91",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21441.044,29290.841l379.64,-120.644",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20980.224,28300.727l179.816,574.612",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20802.108,28658.409l531.846,-170.063",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3610.299,1004.488l-1598.168,-722.887l66.069,-182.606l1608.202,741.313l-76.103,164.18Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "33.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3642.916,1337.87l59.377,-150.776",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "33.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3743.268,1290.128l-142.167,-52.769",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "33.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4077.791,934.122l112.897,-283.119",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "33.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4255.087,841.153l-247.546,-98.841",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "33.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4074.445,1551.474l150.535,-374.423",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "33.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4318.645,1441.734l-347.903,-138.211",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "33.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9585.679,14528.206c-1127.365,-812.499 -2234.623,-2075.664 -1748.744,-3373.192c0,0 776.936,-518.491 2007.139,129.848l1231.053,651.69l-1489.448,2591.654Z",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9074.691,19941.9c-507.637,-240.388 -2671.984,-1369.554 -3057.526,-3298.614c-334.523,-1665.263 939.996,-3912.64 1577.281,-4906.106c-41.015,1317.635 1280.371,2433.396 1917.606,2892.415c542.25,399.347 1140.57,716.064 1775.454,939.846l-2212.815,4372.46Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7497.41,12129.223c138.001,876.173 805.346,1783.357 1941.065,2602.558c512.439,378.789 1075.496,683.602 1672.566,905.483l-2090.72,4137.973c-638.935,-318.317 -2526.48,-1395.514 -2878.56,-3156.262c-291.857,-1463.339 698.307,-3404.153 1357.35,-4489.753l-1.701,0Zm341.226,-974.159c0,0 -2395.982,3243.344 -1942.715,5513.33c453.267,2270.036 3238.142,3434.364 3238.142,3434.364l2330.758,-4607.046c-728.418,-267.198 -1201.742,-484.979 -1877.491,-972.508c-1127.315,-812.499 -2234.573,-2075.664 -1748.694,-3373.192l0,5.052Z",
    style: {
      fill: "#ab530b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7207.203,13039.709c70.276,421.905 236.737,821.903 486.529,1168.83c249.742,346.978 576.112,631.482 953.601,831.456",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9343.14,15505.766l1300.429,697.757",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7392.872,14900.944c0,0 418.154,930.643 1764.6,1535.415",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6324.078,15040.045c0,0 46.867,977.51 696.656,1303.38",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7811.026,11644.245c0,0 -120.444,1256.463 1774.603,2884.012",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8507.682,11877.08c0,0 603.772,-46.917 1486.097,604.773",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5664.235,15882.705c-38.464,622.379 39.314,2878.11 3300.865,4317.189",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26493.954,14627.893l-1383.259,2776.822c0,0 938.345,345.927 204.875,1423.974c0,0 1734.489,720.365 2869.356,-1150.073c1134.868,-1870.489 -1690.973,-3050.723 -1690.973,-3050.723Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23327.688,23114.868c-699.958,0 -1438.43,-286.455 -2196.959,-851.864l2587.553,-4295.431l1539.617,970.807l10.004,4.202c269.099,98.936 553.854,148.305 840.509,145.754c486.229,3.001 961.104,-147.354 1357.3,-429.708l-1891.696,3245.845c-4.202,5.902 -818.751,1212.947 -2246.327,1212.947l0,-2.551Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23760.097,18143.487l1421.673,897.13l18.407,11.704l19.257,7.553c284.455,105.339 585.666,158.108 888.977,155.807c348.478,1.3 693.355,-71.176 1011.923,-212.778l-1650.858,2828.741c-53.52,78.729 -819.602,1157.626 -2140.938,1157.626c-644.787,0 -1327.189,-255.494 -2031.348,-759.78l2462.907,-4086.004Zm4424.829,-465.721c-641.436,1057.089 -1473.542,1286.624 -2076.514,1286.624c-270.3,2.251 -538.798,-44.016 -792.842,-136.55l-1638.303,-1032.83l-2708.747,4499.857c904.883,698.557 1696.825,949.85 2360.019,949.85c1514.558,0 2354.167,-1274.869 2354.167,-1274.869l2502.221,-4287.879l0,-4.202Z",
    style: {
      fill: "#c56210",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25110.695,17404.665c0,0 1031.98,365.234 204.875,1424.024",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23644.655,17697.873c0,0 1405.818,1289.925 2183.604,1280.722c777.736,-9.203 1690.973,-193.471 2228.721,-1123.264",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23817.769,19366.438c0,0 964.255,857.716 2043.102,582.164",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24830.541,20648.06c0,0 505.936,379.44 1213.447,20.057",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22502.284,21177.454c0,0 1170.831,1163.478 3006.507,396.196",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23137.868,20042.437c0,0 476.675,341.726 775.235,450.666",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26731.441,15433.69c0,0 1066.293,349.329 1194.24,1759.048",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27267.489,17175.181c0,0 490.931,761.38 -338.675,1521.96",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21063.855,22085.439c0,0 2676.135,3357.236 4620.551,-568.759",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.83,13760.924l623.88,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#ff6d66",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36506.94,6241.406l623.88,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#ff6d66",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19768.428,1952.702l624.73,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fad8b0",
      strokeWidth: "50.02px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37698.679,9483.949l613.826,110.541",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fad8b0",
      strokeWidth: "50.02px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13180.052,25083.342l624.73,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#a0c6f4",
      strokeWidth: "50.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39043.424,17496.849c114.092,0 206.576,-92.634 206.576,-206.926c0,-114.242 -92.484,-206.876 -206.576,-206.876c-114.092,0 -206.576,92.634 -206.576,206.876c0,114.292 92.484,206.926 206.576,206.926Z",
    style: {
      fill: "#91ba83",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.566,7560.741c114.083,0 206.566,-92.634 206.566,-206.926c0,-114.242 -92.483,-206.876 -206.566,-206.876c-114.083,0 -206.566,92.634 -206.566,206.876c0,114.292 92.483,206.926 206.566,206.926Z",
    style: {
      fill: "#91ba83",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3942.151314,11.154106,-11.154106,3942.151314,24906.919554,16567.207163)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ab530b",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f07b19",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3942.151314,11.154106,-11.154106,3942.151314,24906.919554,16567.207163)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ab530b",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f07b19",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact-img.b64412eda48d341fa396e002634bc0c0.svg";
export { ForwardRef as ReactComponent };